/* ============================================================
   tio-cart.js - Cart drawer global.
   Ver CartDrawer.spec.md.

   Tras CADA mutacion del carrito se re-pide la section entera
   (/?section_id=tio-cart-drawer) en vez de re-renderizar a mano:
   el markup tiene UNA sola fuente de verdad, que es Liquid.

   Regalos: la logica de umbrales se porta 1:1 de _reconcileGifts().
   Los regalos NO suman al subtotal ni cuentan para los hitos; si
   cuentan en "N items", igual que cart.item_count.
   ============================================================ */
(function () {
  'use strict';

  var SECCION = 'tio-cart-drawer';
  var CLAVE_DESCARTADOS = 'tio_regalos_descartados';
  var abierto = false;
  var trigger = null;
  var reconciliando = false;

  function panel() { return document.querySelector('[data-tio-cart-panel]'); }
  function overlay() { return document.querySelector('[data-tio-cart-ov]'); }

  /* ---------- descartados: la X manual de un regalo no se re-agrega
     hasta bajar del umbral y volver a cruzarlo ---------- */
  function descartados() {
    try { return JSON.parse(sessionStorage.getItem(CLAVE_DESCARTADOS) || '[]'); }
    catch (e) { return []; }
  }
  function guardarDescartados(a) {
    try { sessionStorage.setItem(CLAVE_DESCARTADOS, JSON.stringify(a)); } catch (e) {}
  }
  function descartar(id) {
    var a = descartados();
    if (a.indexOf(String(id)) === -1) { a.push(String(id)); guardarDescartados(a); }
  }
  function rearmar(id) {
    guardarDescartados(descartados().filter(function (x) { return x !== String(id); }));
  }

  /* ---------- scroll lock sin salto ---------- */
  function bloquear(si) {
    if (si) {
      var comp = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';
      if (comp > 0) document.body.style.paddingRight = comp + 'px';
    } else {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }
  }

  function abrir(desde) {
    var p = panel(), o = overlay();
    if (!p || abierto) return;
    abierto = true;
    trigger = desde || null;
    p.classList.add('is-anim', 'is-open');
    if (o) o.classList.add('is-open');
    p.setAttribute('aria-hidden', 'false');
    bloquear(true);
    var x = p.querySelector('[data-tio-cart-close]');
    if (x) x.focus();
    setTimeout(function () { p.classList.remove('is-anim'); }, 400);
  }

  function cerrar() {
    var p = panel(), o = overlay();
    if (!p || !abierto) return;
    abierto = false;
    p.classList.add('is-anim');
    p.classList.remove('is-open');
    if (o) o.classList.remove('is-open');
    p.style.transform = '';
    bloquear(false);
    /* aria-hidden espera el FIN de la salida (spec, seccion Panel) */
    setTimeout(function () {
      if (!abierto) p.setAttribute('aria-hidden', 'true');
      p.classList.remove('is-anim');
    }, 330);
    if (trigger && trigger.focus) trigger.focus();
    trigger = null;
  }

  /* ---------- re-render por Section Rendering API ---------- */
  function repintar() {
    return fetch('/?section_id=' + SECCION, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var viejo = panel();
        var ov = overlay();
        if (!viejo) return;
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var nuevoPanel = temp.querySelector('[data-tio-cart-panel]');
        var nuevoOv = temp.querySelector('[data-tio-cart-ov]');
        if (!nuevoPanel) return;
        if (abierto) {
          nuevoPanel.classList.add('is-open');
          nuevoPanel.setAttribute('aria-hidden', 'false');
          if (nuevoOv) nuevoOv.classList.add('is-open');
        }
        viejo.replaceWith(nuevoPanel);
        if (ov && nuevoOv) ov.replaceWith(nuevoOv);
      });
  }

  function sincronizarContador() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (typeof window.tioActualizarCarrito === 'function') window.tioActualizarCarrito(c.item_count);
        return c;
      });
  }

  /* ---------- REGALOS: portado de _reconcileGifts() ---------- */
  function reconciliarRegalos(carrito) {
    if (reconciliando) return Promise.resolve();
    var p = panel();
    if (!p) return Promise.resolve();

    /* Subtotal SIN regalos: los regalos no cuentan para los hitos. */
    var sub = 0;
    var enCarrito = {};
    carrito.items.forEach(function (it) {
      var esRegalo = it.properties && it.properties._te_gift;
      if (esRegalo) enCarrito[String(it.variant_id)] = it;
      else sub += it.final_line_price;
    });

    var desc = descartados();
    var acciones = [];

    p.querySelectorAll('[data-tio-mile]').forEach(function (m) {
      var idRegalo = m.getAttribute('data-regalo');
      if (!idRegalo) return;                       /* hito sin regalo, p.ej. envio */
      var monto = parseInt(m.getAttribute('data-monto'), 10);
      var alcanzado = sub >= monto;
      var puesto = !!enCarrito[idRegalo];

      if (alcanzado && !puesto && desc.indexOf(String(idRegalo)) === -1) {
        acciones.push({ tipo: 'add', id: idRegalo });
      } else if (!alcanzado) {
        /* Bajo del umbral: se quita y se REARMA el derecho a re-agregarlo. */
        rearmar(idRegalo);
        if (puesto) acciones.push({ tipo: 'quitar', key: enCarrito[idRegalo].key });
      }
    });

    if (!acciones.length) return Promise.resolve();
    reconciliando = true;

    var cadena = Promise.resolve();
    acciones.forEach(function (a) {
      cadena = cadena.then(function () {
        if (a.tipo === 'add') {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(a.id), quantity: 1, properties: { _te_gift: 'true' } }] })
          }).then(function (r) {
            /* Si el regalo esta agotado, el add falla. NO se rompe el carrito:
               se registra y el circuito sigue funcionando sin ese regalo. */
            if (!r.ok) console.warn('[tio-cart] no se pudo agregar el regalo', a.id, '- revisar stock');
          });
        }
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: a.key, quantity: 0 })
        });
      });
    });

    return cadena
      .catch(function (e) { console.error('[tio-cart] regalos', e); })
      .finally(function () { reconciliando = false; });
  }

  function refrescar() {
    return sincronizarContador()
      .then(reconciliarRegalos)
      .then(repintar)
      .then(sincronizarContador);
  }

  /* ---------- Listeners delegados (doctrina 8.1) ---------- */
  document.addEventListener('click', function (e) {
    /* Abrir desde el carrito del header. El <a href="/cart"> queda como
       fallback: sin JS lleva al carrito y la compra sigue siendo posible. */
    var btnCarrito = e.target.closest('[data-te-cart]');
    if (btnCarrito) {
      if (!panel()) return;                        /* sin drawer, deja navegar */
      e.preventDefault();
      abrir(btnCarrito);
      refrescar();
      return;
    }

    if (e.target.closest('[data-tio-cart-close]')) { cerrar(); return; }
    if (abierto && e.target.closest('[data-tio-cart-ov]')) { cerrar(); return; }

    var qty = e.target.closest('[data-tio-qty]');
    if (qty) {
      var fila = qty.closest('[data-tio-linea]');
      var n = fila ? parseInt(fila.querySelector('.tec-step .n').textContent, 10) : 1;
      var nueva = n + parseInt(qty.getAttribute('data-delta'), 10);
      if (nueva < 1) return;
      qty.disabled = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: qty.getAttribute('data-tio-qty'), quantity: nueva })
      }).then(refrescar);
      return;
    }

    var quitar = e.target.closest('[data-tio-quitar]');
    if (quitar) {
      /* X manual sobre un regalo: se marca descartado y no vuelve hasta
         bajar del umbral y volver a cruzarlo. */
      var idRegalo = quitar.getAttribute('data-regalo-key');
      if (idRegalo) descartar(idRegalo);
      quitar.disabled = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: quitar.getAttribute('data-tio-quitar'), quantity: 0 })
      }).then(refrescar);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') cerrar();
  });

  /* Cuando el Quick View (u otra superficie) agrega, refrescar el drawer. */
  document.addEventListener('tio:cart:updated', function () { refrescar(); });

  /* ---------- Swipe hacia la derecha para cerrar ---------- */
  var arrastre = null;
  document.addEventListener('pointerdown', function (e) {
    var p = panel();
    if (!abierto || !p || !p.contains(e.target) || e.pointerType === 'mouse') return;
    if (e.target.closest('.tec-scroll')) return;   /* la lista scrollea, no arrastra */
    arrastre = { x0: e.clientX };
  });
  document.addEventListener('pointermove', function (e) {
    if (!arrastre) return;
    var p = panel();
    var dx = Math.max(0, e.clientX - arrastre.x0);
    arrastre.dx = dx;
    p.style.transition = 'none';
    p.style.transform = 'translateX(' + dx + 'px)';
  });
  function soltar() {
    if (!arrastre) return;
    var p = panel();
    var dx = arrastre.dx || 0;
    arrastre = null;
    p.style.transition = '';
    p.style.transform = '';
    if (dx > 90) cerrar();
  }
  document.addEventListener('pointerup', soltar);
  document.addEventListener('pointercancel', soltar);

  window.tioCart = { abrir: abrir, cerrar: cerrar, refrescar: refrescar };
})();
